export default "__VITE_ASSET__IGwvatLx__"